// extracted by mini-css-extract-plugin
module.exports = {"dragAndDrop":"drag_and_drop_dragAndDrop__1e5R7","dragging":"drag_and_drop_dragging__2nVan"};